/** @module CollectionBook/MCAggregateProducts */
define([
	"dojo/_base/declare",
	"csi/table/AggregateFrom"
], function(declare,AggregateFrom) {

	return declare(AggregateFrom, {
		getFormData: function() {
			// summary: C8-5382 if MarketingCollectionNode.AllowDuplicateProducts = true, allow duplicate products
			var marketingCollectionNode = this.getParent();
			if (marketingCollectionNode && marketingCollectionNode.AllowDuplicateProducts) {
				this.m_action.bAggregateAdd = true;
			}

			return this.inherited(arguments);
		}
	});
});